import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { ModalInformation } from '@panel/commons/lib/Modals/ModalInformation';

function NormalFlowDraftToOnCreditsNoEcomYes(props) {
  const { onClickCancel, postingId, isComplete, isInmobiliaria } = props;
  const { t } = useTranslation();

  const url = isInmobiliaria
    ? `..${t('panel.url.ecommerce.professional')}?idPosting=${postingId}`
    : `..${t('panel.url.ecommerce.particular')}?idPosting=${postingId}`;

  useEffect(() => {
    sendTrackingInfo(
      'Mis avisos',
      `Publicar Aviso con Datos ${isComplete ? 'completos' : 'incompletos'}_sin credito-Intencion`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModalInformation
      onClickAction={onClickCancel}
      onClickCancel={onClickCancel}
      onClickOutside={onClickCancel}
      title={t('panel.modal.NormalFlowDraftToOnCreditsNoEcomYes.title')}
      ctaCancel={t('panel.modal.cta.cancel')}
      urlLink={url}
      ctaAnchor={t('panel.modal.cta.buyCredits')}
    />
  );
}

export { NormalFlowDraftToOnCreditsNoEcomYes };
